module.exports = __webpack_public_path__ + "static/media/support4.d30ece11.png";